// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"e77c32ef","655":"a31dbae6"}[chunkId] + ".chunk.js";
};